const colors = {
  primaryBlue: "#1197D9",
  primaryBlue50: "#5EC1D450",
  secondaryGrey: "#EDEDED",
  primaryOrange: "#FDAD02",
  primaryOrange50: "#FDAD0250",
  white: "#FFFFFF",
  secondaryDarkBlue: "#2C3751",
  secondaryOrange: "#FC6401",
  orangeDark: "#D86300",
  primaryPurple: "#773098",
  primaryPink: "#EF91BB",
  secondaryPink: "#C55588",
  greenDark: "#1B5448",
  greenLight: "#24855B",
  greenLight50: "#24855B50",
};

export { colors };
